
import { ProfessionData } from '../types/professionTypes';

export const boulanger: ProfessionData = {
  title: "Boulanger",
  slug: "boulanger",
  description: "Solutions de valorisation des déchets de boulangerie",
  icon: "Wheat",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Déchets organiques",
      description: "Invendus de pain, viennoiseries et résidus de préparation.",
      solutions: ["Collecte alimentaire", "Compostage"],
      environmentalBenefit: "Valorisation en alimentation animale et amendement"
    },
    {
      type: "Huiles alimentaires",
      description: "Huiles de friture usagées des préparations de beignets et autres fritures.",
      solutions: ["Fûts de récupération", "Conversion en biocarburant"],
      environmentalBenefit: "Production d'énergie renouvelable"
    },
    {
      type: "Emballages professionnels",
      description: "Sacs de farine, cartons, films plastiques et contenants divers.",
      solutions: ["Tri sélectif adapté", "Compactage"],
      environmentalBenefit: "Réduction volume et valorisation matière"
    }
  ],
  relatedProfessions: ["patissier", "restaurateur", "traiteur"]
};
